// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_BucketsPageContent_card__yfnU7 {
  overflow: hidden;
}

.storage_BucketsPageContent_card__yfnU7 h5 {
  padding: 16px 0 16px 16px;
  font-weight: 700;
}

.storage_BucketsPageContent_cardContent__kslNz {
  position: relative;
  overflow: auto;
  min-height: 400px;
}

.storage_BucketsPageContent_tableBlock__Pp9EH {
  padding: 16px;
}

.storage_BucketsPageContent_filtersBlock__SRG2O {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;
}

.storage_BucketsPageContent_filtersLeft__ydF9X {
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  gap: 16px;
}

.storage_BucketsPageContent_filterBar__UzcjN {
  width: 25%;
  min-width: 200px;
  height: auto;
}

.storage_BucketsPageContent_filterBar__UzcjN:first-child {
  width: 176px;
}

.storage_BucketsPageContent_filterBar__UzcjN:last-child {
  width: 245px;
}

.storage_BucketsPageContent_filterLabel__YGe7Z {
  margin-bottom: 4px;
  color: var(--color-grey-08);
  font-size: 14px;
  line-height: 1.2;
}

.storage_BucketsPageContent_filterInput__7-CXE {
  width: 100%;
  min-height: 37px !important;
}

.storage_BucketsPageContent_actionsBlock__1nFrx {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-left: auto;
  gap: 16px;
}

.storage_BucketsPageContent_actionBtn__QHc-R {
  min-width: 120px;
  min-height: 37px !important;
}

.storage_BucketsPageContent_totalSize__QMw7\\+ {
  margin: 8px 0 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
}

.storage_BucketsPageContent_titleContainer__7FOpl {
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 1024px) {
  .storage_BucketsPageContent_filtersBlock__SRG2O {
    align-items: stretch;
  }

  .storage_BucketsPageContent_actionsBlock__1nFrx {
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .storage_BucketsPageContent_filtersBlock__SRG2O {
    flex-direction: column;
    align-items: stretch;
  }

  .storage_BucketsPageContent_filtersLeft__ydF9X {
    width: 100%;
    flex-direction: column;
    gap: 12px;
  }

  .storage_BucketsPageContent_filterBar__UzcjN,
  .storage_BucketsPageContent_filterBar__UzcjN:first-child,
  .storage_BucketsPageContent_filterBar__UzcjN:last-child {
    width: 100%;
    min-width: 100%;
  }

  .storage_BucketsPageContent_actionsBlock__1nFrx {
    width: 100%;
    justify-content: stretch;
    margin-left: 0;
    gap: 12px;
  }

  .storage_BucketsPageContent_actionBtn__QHc-R {
    min-width: 0;
    flex: 1 1;
  }

  .storage_BucketsPageContent_totalSize__QMw7\\+ {
    margin-top: 16px;
  }
}

@media (max-width: 480px) {
  .storage_BucketsPageContent_actionsBlock__1nFrx {
    flex-direction: column;
  }

  .storage_BucketsPageContent_actionBtn__QHc-R {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/BucketsPageContent.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".card {\n  overflow: hidden;\n}\n\n.card h5 {\n  padding: 16px 0 16px 16px;\n  font-weight: 700;\n}\n\n.cardContent {\n  position: relative;\n  overflow: auto;\n  min-height: 400px;\n}\n\n.tableBlock {\n  padding: 16px;\n}\n\n.filtersBlock {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.filtersLeft {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.filterBar {\n  width: 25%;\n  min-width: 200px;\n  height: auto;\n}\n\n.filterBar:first-child {\n  width: 176px;\n}\n\n.filterBar:last-child {\n  width: 245px;\n}\n\n.filterLabel {\n  margin-bottom: 4px;\n  color: var(--color-grey-08);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.filterInput {\n  width: 100%;\n  min-height: 37px !important;\n}\n\n.actionsBlock {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  margin-left: auto;\n  gap: 16px;\n}\n\n.actionBtn {\n  min-width: 120px;\n  min-height: 37px !important;\n}\n\n.totalSize {\n  margin: 8px 0 16px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 125%;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n@media (max-width: 1024px) {\n  .filtersBlock {\n    align-items: stretch;\n  }\n\n  .actionsBlock {\n    gap: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .filtersBlock {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filtersLeft {\n    width: 100%;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .filterBar,\n  .filterBar:first-child,\n  .filterBar:last-child {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .actionsBlock {\n    width: 100%;\n    justify-content: stretch;\n    margin-left: 0;\n    gap: 12px;\n  }\n\n  .actionBtn {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .totalSize {\n    margin-top: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .actionsBlock {\n    flex-direction: column;\n  }\n\n  .actionBtn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `storage_BucketsPageContent_card__yfnU7`,
	"cardContent": `storage_BucketsPageContent_cardContent__kslNz`,
	"tableBlock": `storage_BucketsPageContent_tableBlock__Pp9EH`,
	"filtersBlock": `storage_BucketsPageContent_filtersBlock__SRG2O`,
	"filtersLeft": `storage_BucketsPageContent_filtersLeft__ydF9X`,
	"filterBar": `storage_BucketsPageContent_filterBar__UzcjN`,
	"filterLabel": `storage_BucketsPageContent_filterLabel__YGe7Z`,
	"filterInput": `storage_BucketsPageContent_filterInput__7-CXE`,
	"actionsBlock": `storage_BucketsPageContent_actionsBlock__1nFrx`,
	"actionBtn": `storage_BucketsPageContent_actionBtn__QHc-R`,
	"totalSize": `storage_BucketsPageContent_totalSize__QMw7+`,
	"titleContainer": `storage_BucketsPageContent_titleContainer__7FOpl`
};
export default ___CSS_LOADER_EXPORT___;
